/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Guidevideo_Group_Merge_Note1Inputs */

const vi_guidevideo_group_merge_note1 = /** @type {(inputs: Guidevideo_Group_Merge_Note1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sẽ gộp vào nhóm "${i?.name}" đang có.`)
};

/**

* @param {Guidevideo_Group_Merge_Note1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_group_merge_note1 = /** @type {((inputs: Guidevideo_Group_Merge_Note1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Group_Merge_Note1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_group_merge_note1(inputs)
});
export { guidevideo_group_merge_note1 as "guideVideo_group_merge_note" }